import { useEffect } from 'react';

// Contador global: puede haber mas de un componente pidiendo el bloqueo al
// mismo tiempo (ej. la pagina de cuenta corriente Y el modal de edicion de
// remito que abre arriba). Si cada uno guardara y restaurara su propio "valor
// original" por separado, el que se cierra segundo pisa el scroll con el
// valor ya bloqueado del primero, dejandolo trabado. Con un contador, el
// scroll solo se libera cuando el ultimo interesado se va.
let lockCount = 0;
let previousOverflow: string | null = null;

// Bloquea el scroll del body mientras `locked` es true (un modal o menu movil
// abierto), para que en celulares el gesto de scroll no se "escape" hacia el
// contenido de atras en vez de mover lo que esta arriba.
export default function useBodyScrollLock(locked: boolean): void {
  useEffect(() => {
    if (!locked) return;
    if (lockCount === 0) {
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
    lockCount += 1;
    return () => {
      lockCount = Math.max(0, lockCount - 1);
      if (lockCount === 0) {
        document.body.style.overflow = previousOverflow || '';
        previousOverflow = null;
      }
    };
  }, [locked]);
}
